import classNames from 'classnames';
import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import {dateChange} from '../../../general/actionCreators';
import {getCurrentDate} from '../../../general/selectors';

import {createMetSelectWrapper, MetSelectInput, MetSelectList} from '../../../general/components/MetSelectWrapper';

import DateItem from './DateItem';

const OptGroupLabel = gettext('Day');

const DateSelect = ({dates, title, offset, runState, onChange, ...props}) => (
    <div className={classNames('met-select-wrapper', `runinfo-${runState}`, {'is-past': offset < 0})}>
        <span className="run-status" />
        <select className="met-select" value={offset} onChange={onChange}>
            <optgroup label={OptGroupLabel}>
                {dates.filter(({available}) => available).map(({offset, shortTitle}) => (
                    <option key={offset} value={offset}>{shortTitle}</option>
                ))}
            </optgroup>
        </select>
        <div className="styled-dropdown">
            <MetSelectInput
                {...props}
                className={`runinfo-${runState}`}
                value={title}
            />
            <MetSelectList {...props}>
                {dates.map(date => <DateItem {...date} key={date.offset} />)}
            </MetSelectList>
        </div>
    </div>
);

const DateSelectWrapper = createMetSelectWrapper(DateSelect);

const mapStateToProps = state => {
    const {dates, offset} = state;
    const {state: runState, title} = getCurrentDate(state);

    return {
        dates,
        title,
        offset,
        runState,
    };
};

const mapDispatchToProps = dispatch => ({
    onChange: ({target: {value}}) => dispatch(dateChange(+value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DateSelectWrapper);
